import { createContext } from "react";

/**
 * Quién descarta un bloque de terreno. Lo provee UNA vez el editor del informe
 * ({@link ProveedorDeDescarteDeTerreno}) para la pestaña «Registro de terreno»
 * y los paneles de las pestañas técnicas. Sin proveedor, o sin permiso
 * (`puede_descartar` falso), vale `null` y ningún botón se dibuja.
 *
 * Es contexto y no una prop porque el botón vive en piezas que están cinco
 * niveles bajo la pestaña (tarjeta de foto, de audio, de texto, de registro…).
 */
export const DescarteDeTerrenoContext = createContext<((uuid: string) => void) | null>(null);
